// src/components/aols/aeo/OLSupdates/OLS2900/OLS2922.tsx
import React from "react";
import { Layout, Typography, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import { HomeOutlined } from "@ant-design/icons";
import { InlineShareButtons } from "sharethis-reactjs";
import Footer from "../../../../dev/utils/Footer/Footer";
import { updates2900 } from "./OLS2900"; // Ensure the import is correct

const { Title, Paragraph } = Typography;

const UpdateContainer = styled.div`
  background: #000000;
  min-height: 100vh;
  padding: 40px 20px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UpdateContent = styled.div`
  max-width: 800px;
  width: 100%;
  background: #1a1a1a;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  text-align: center;
`;

const UpdateTitle = styled(Title)`
  && {
    color: #ffcc00 !important;
    margin-bottom: 20px;
  }
`;

const UpdateParagraph = styled(Paragraph)`
  && {
    color: #fff !important;
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 24px;
  }
`;

const UpdateLink = styled.a`
  color: #ffaa00 !important;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;

  &:hover {
    color: #ffcc00 !important;
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #40c4ff;
    outline-offset: 2px;
  }
`;

const HighlightedText = styled.span`
  font-size: 48px;
  color: #ffcc00;
`;

const UpdateImage = styled.img`
  max-width: 100%;
  border-radius: 8px;
  margin: 20px 0;
`;

const BreadcrumbWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 20px;
  z-index: 1001;

  .ant-breadcrumb a {
    color: #ffcc00;
    transition: color 0.3s ease;
  }

  .ant-breadcrumb a:hover {
    color: #ffaa00;
  }

  @media (max-width: 768px) {
    left: 10px;
    top: 5px;
    .ant-breadcrumb {
      font-size: 12px;
    }
  }
`;

const ShareThisWrapper = styled.div`
  margin-top: 20px;
  padding: 10px;
  background: #1a1a1a;
  border-radius: 8px;
  display: flex;
  justify-content: center;

  .st-btn {
    border: 1px solid #ffcc00 !important;
    border-radius: 4px !important;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }

    &:focus {
      outline: 2px solid #40c4ff;
      outline-offset: 2px;
    }
  }

  .st-total {
    color: #fff !important;
    font-size: 16px;
  }
`;

const OLS2922: React.FC = () => {
  // Debug logs to confirm updates2900 contents and update retrieval
  console.log("OLS2922 component rendering - updates2900:", updates2900);
  const update = updates2900.find((u) => u.id === "2922");
  console.log("OLS2922 - Retrieved update:", update);

  if (!update) {
    console.log("Update 2922 not found in updates2900");
    return null;
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: "Celebrating 8 Years of OLS: 20% Discount for New Students - onelightsystem OLS 8.0",
    description:
      "Join us in celebrating 8 years of onelightsystem OLS with a special 20% discount for new student registrations today, April 24, 2025. Learn more about becoming an OLS student prospect at /OLSStudentProspect.",
    url: "https://www.olsme.com/olsupdates/ols2900/2922",
    datePublished: "2025-04-24",
    author: {
      "@type": "Organization",
      name: "onelightsystem OLS",
      url: "https://www.olsme.com",
    },
    publisher: {
      "@type": "Organization",
      name: "onelightsystem OLS",
      url: "https://www.olsme.com",
      logo: "https://www.olsme.com/logo.jpg",
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.olsme.com/olsupdates/ols2900/2922",
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.olsme.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "OLS Updates",
          item: "https://www.olsme.com/olsupdates",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "OLS2900",
          item: "https://www.olsme.com/olsupdates/ols2900",
        },
        {
          "@type": "ListItem",
          position: 4,
          name: "Celebrating 8 Years of OLS: 20% Discount for New Students",
          item: "https://www.olsme.com/olsupdates/ols2900/2922",
        },
      ],
    },
  };

  return (
    <Layout>
      <Helmet>
        <title>Celebrating 8 Years of OLS: 20% Discount for New Students - onelightsystem OLS 8.0</title>
        <meta
          name="description"
          content="Join us in celebrating 8 years of onelightsystem OLS with a special 20% discount for new student registrations today, April 24, 2025. Learn more about becoming an OLS student prospect at /OLSStudentProspect."
        />
        <meta
          name="keywords"
          content="OLS anniversary, 8 years, 20% discount, OLS student prospect, onelightsystem OLS, Sun Light Meditation, OLS updates, Light Civilization, meditation education"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="onelightsystem OLS" />
        <link
          rel="canonical"
          href="https://www.olsme.com/olsupdates/ols2900/2922"
        />
        <meta
          property="og:title"
          content="Celebrating 8 Years of OLS: 20% Discount for New Students - onelightsystem OLS 8.0"
        />
        <meta
          property="og:description"
          content="Join us in celebrating 8 years of onelightsystem OLS with a special 20% discount for new student registrations today, April 24, 2025. Learn more about becoming an OLS student prospect at /OLSStudentProspect."
        />
        <meta
          property="og:url"
          content="https://www.olsme.com/olsupdates/ols2900/2922"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://via.placeholder.com/1200x630?text=OLS+8th+Anniversary" // Placeholder image to bypass ORB errors
        />
        <meta
          property="og:image:alt"
          content="OLS 8th Anniversary Celebration - 20% Discount Offer"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="onelightsystem OLS" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@onelightsystem" />
        <meta
          name="twitter:title"
          content="Celebrating 8 Years of OLS: 20% Discount for New Students - onelightsystem OLS 8.0"
        />
        <meta
          name="twitter:description"
          content="Join us in celebrating 8 years of onelightsystem OLS with a special 20% discount for new student registrations today, April 24, 2025. Learn more about becoming an OLS student prospect at /OLSStudentProspect."
        />
        <meta
          name="twitter:image"
          content="https://via.placeholder.com/1200x630?text=OLS+8th+Anniversary" // Placeholder image to bypass ORB errors
        />
        <meta
          name="twitter:image:alt"
          content="OLS 8th Anniversary Celebration - 20% Discount Offer"
        />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <BreadcrumbWrapper>
        <Breadcrumb
          items={[
            {
              title: (
                <Link to="/">
                  <HomeOutlined /> Home
                </Link>
              ),
            },
            {
              title: <Link to="/olsupdates">OLS Updates</Link>,
            },
            {
              title: <Link to="/olsupdates/ols2900">OLS2900</Link>,
            },
            {
              title: "Celebrating 8 Years of OLS: ONLY TODAY 4/24 a 20% Discount for New Students",
            },
          ]}
        />
      </BreadcrumbWrapper>

      <UpdateContainer>
        <UpdateContent>
          <UpdateTitle level={1}>Celebrating 8 Years of OLS: ONLY TODAY 4/24 a 20% Discount for New Students</UpdateTitle>
          <UpdateParagraph>
            Today, April 24, 2025, marks a luminous milestone for onelightsystem OLS as we celebrate our <HighlightedText>8th Anniversary</HighlightedText>! 🎉 Since our founding in 2017, we’ve been dedicated to empowering individuals through Sun Light Meditation, fostering a global community of light and growth. We’re thrilled to share this special day with you by offering an exclusive <HighlightedText> 20% discount</HighlightedText> on all new student registrations completed today!
          </UpdateParagraph>
          <UpdateParagraph>
            This is a welcoming opportunity to join the OLS family and embark on a transformative journey towards personal illumination and spiritual development. Whether you’re a beginner or seeking to advance your meditation practice, OLS offers a supportive path from student to meditation master. Learn more about becoming an OLS student prospect and take the first step towards a brighter future by visiting <UpdateLink href="/OLSStudentProspect" aria-label="Learn more about OLS student prospect">/OLSStudentProspect</UpdateLink>.
          </UpdateParagraph>
          <UpdateParagraph>
            Don’t miss this limited-time offer to save 20% on your registration fees! Register today at <UpdateLink href="https://www.olsme.com/olssregister" target="_blank" rel="noopener noreferrer" aria-label="Register now at olsme.com">www.olsme.com/olssregister</UpdateLink> and start your journey with OLS. Let’s continue to build a radiant Sun Light Civilization together!
          </UpdateParagraph>
          <UpdateImage
            src="https://via.placeholder.com/800x400?text=OLS+8th+Anniversary" // Placeholder image to bypass ORB errors
            alt="OLS 8th Anniversary Celebration - ONLY TODAY 4/24 a 20% Discount Offer"
          />

          <ShareThisWrapper>
            <InlineShareButtons
              config={{
                alignment: "center",
                color: "social",
                enabled: true,
                font_size: 16,
                labels: "cta",
                language: "en",
                networks: [
                  "whatsapp",
                  "linkedin",
                  "messenger",
                  "facebook",
                  "twitter",
                  "blogger",
                  "pinterest",
                  "sms",
                ],
                padding: 12,
                radius: 4,
                show_total: true,
                min_count: 10,
                url: "https://www.olsme.com/olsupdates/ols2900/2922",
                image:
                  "https://via.placeholder.com/1200x630?text=OLS+8th+Anniversary", // Placeholder image to bypass ORB errors
                description:
                  "Celebrate 8 years of onelightsystem OLS with a 20% discount on new student registrations today, April 24, 2025! Learn more at /OLSStudentProspect.",
                title: "Celebrating 8 Years of OLS: 20% Discount for New Students - onelightsystem OLS 8.0",
                message:
                  "Join OLS on our 8th anniversary and save 20% on your registration today!",
                subject: "OLS 8th Anniversary: ONLY TODAY 4/24 a 20% Discount Offer",
                username: "onelightsystem",
              }}
            />
          </ShareThisWrapper>
        </UpdateContent>
      </UpdateContainer>

      <Footer />
    </Layout>
  );
};

export default OLS2922;